import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { Clients } from "@/lib/clients";
import { useParams } from "react-router-dom";
import { E2PositionsEditCard } from "./edit_card";
import { Tables } from "@/gen/tableNames/tables";

export const E2PositionsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <E2PositionsEditCard
          id={Number(id)}
          client={Clients.E2}
          table_name={Tables.E2_POSITIONS}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.E2}
          audit_table_name={Tables.E2_POSITIONS}
        />
      </div>
    </div>
  );
};
